import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useChapterCreate } from '@/module/Author/Chapter/model/ChapterQuery';
import { ChapterSchema, chapterSchema, defaultChapterValues } from '@/module/Author/Chapter/model/ChapterSchema';

import { useAppNotification } from '@feature/utils';

import { ChapterForm } from './ChapterForm';

export function ChapterCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useChapterCreate();
  const navigate = useNavigate();
  const notification = useAppNotification();

  const onSubmit = (values: ChapterSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newChapter => {
        notification.success();
        navigate({ to: '/author/chapter/$chapterId', params: { chapterId: String(newChapter.id) } });
      },
    });
  };

  return (
    <ChapterForm
      title={t('chapters.form.title.create')}
      schema={chapterSchema}
      defaultValues={defaultChapterValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
      showWosFields={false}
      showScopusFields={false}
    />
  );
}
